import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { concatMap, map } from 'rxjs/operators';
import { OrdersFacade } from '../facades/orders.facade';
import { IArchiveOrder, IArchiveOrderResponse } from '../models/order.models';
import { CustomerActions, HybrisOrdersActions } from '../actions';
import { EStoreFeatures } from '../configurations/common';
import { ConfigurationFacade } from '../facades/configuration.facade';

@Injectable({
  providedIn: 'root',
})
export class HybrisOrdersEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly ordersFacade: OrdersFacade = inject(OrdersFacade);
  private readonly configurationFacade: ConfigurationFacade = inject(ConfigurationFacade);

  readonly initHybrisOrdersAfterLogin$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerActions.CompanyUsersActionSuccess),
      concatMap(() => {
        if (this.configurationFacade.isFeatureAvailable(EStoreFeatures.SPARE_PARTS)) {
          return [
            HybrisOrdersActions.retrieveHybrisOrders(),
          ];
        } else {
          return [];
        }
      }),
    );
  });

  readonly retrieveHybrisOrders$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(HybrisOrdersActions.retrieveHybrisOrders),
      mergeMap(() => this.ordersFacade.getArchiveOrders().pipe(
        map((data: IArchiveOrderResponse) => {
          return HybrisOrdersActions.retrieveHybrisOrdersSuccess({
            hybrisOrders: data.data as IArchiveOrder[],
          });
        }),
      )),
    ));
}
